module.exports = __webpack_public_path__ + "img/close-quote.545f8597.svg";